export default class StringHelper {
  static toTitleString = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
  };
}
